import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip } from '@fluentui/react-components';
import { EyeOff20Regular, EyeOffRegular } from '@fluentui/react-icons';

// styles
import './ConsumptionDetailMenu.Styles.css';

// import functions
import * as ComponentFunctions from './ConsumptionDetailMenu.Functions';

/**
 * Barra de opciones del detalle (guía): a la izquierda el rótulo y qué hace, a la derecha las
 * acciones "Ignorar" e "Ignorar todos los de este tipo". Los consumos agrupados no se ignoran
 * desde acá, así que la barra no se muestra.
 *
 * La marca de seguimiento vivía también acá; ahora es una de las condiciones del consumo y se
 * maneja en la sección de clasificación, junto a la discontinuación temprana y la agrupación.
 */
const ConsumptionDetailMenu = (props: ComponentFunctions.Props) => {
    const { t } = useTranslation();

    const dispatchChangeStatus = (setAll: boolean) => {
        props.ChangeStatus(props.ProtocolId, props.ProtocolConsumptionId, 5, setAll);
    };

    if (props.Consumption?.groupingId) {
        return null;
    }

    return (
        <div className="cdm-bar" role="toolbar" aria-label={t('consumptionDetailMenu.title', 'Acciones')} data-testid="consumption-detail-menu">
            <div className="cdm-bar__text">
                <span className="cdm-bar__title">{t('consumptionDetailMenu.title', 'Acciones')}</span>
                <span className="cdm-bar__hint">{t('consumptionDetailMenu.hint', 'Ignorar saca el consumo de la liquidación; se puede revertir cambiando su estado.')}</span>
            </div>
            <div className="cdm-bar__actions">
                <Tooltip content={t('consumptionDetailMenu.ignore.tooltip', 'Ignore this consumption')} relationship="description">
                    <Button appearance="secondary" icon={<EyeOffRegular />} onClick={() => dispatchChangeStatus(false)} data-testid="cdm-ignore">
                        {t('consumptionDetailMenu.ignore.button', 'Ignore')}
                    </Button>
                </Tooltip>
                <Tooltip content={t('consumptionDetailMenu.ignoreAll.tooltip', 'Ignore all consumptions of this type')} relationship="description">
                    <Button appearance="secondary" icon={<EyeOff20Regular />} onClick={() => dispatchChangeStatus(true)} data-testid="cdm-ignore-all">
                        {t('consumptionDetailMenu.ignoreAll.button', 'Ignore all')}
                    </Button>
                </Tooltip>
            </div>
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ConsumptionDetailMenu as any);
